import { useMemo } from "react";

const useStableObj = (unstable = {}) => {
  // eslint-disable-next-line
  return useMemo(() => unstable, [...Object.values(unstable)]);
};
export default useStableObj;
